// extracted by mini-css-extract-plugin
module.exports = {"text":"ContentBlockText_text__bpIdE"};